module.exports = __webpack_public_path__ + "img/11.a6a6d8a6.webp";